import { createContext, useContext, useState } from "react";
// Define context for cursor
export const CursorContext = createContext(null);

// Define custom hook for cursor

export const CursorContextProvider = ({ children }) => {
  const initialCss = {
    background: "rgba(0, 255, 255,.7) ",
    height: 32,
    width: 32,
    mixBlendMode: "difference",
  };
  const [text, setText] = useState("");
  const [css, setCss] = useState(initialCss);
  return (
    <CursorContext.Provider value={{ text, setText, setCss, css, initialCss }}>
      {children}
    </CursorContext.Provider>
  );
};

export const useCursor = () => useContext(CursorContext);
